/*
 * PostHog events for the free-event web flow (design Req 15). No PII: never
 * an email, phone, name, company, code or token — only step names, state
 * names, error codes and plan choices. `capture` buffers before PostHog
 * initializes and is a no-op without a key (utils/posthog).
 */
import { capture } from "utils/posthog";

// `capture` never throws, so analytics can't break the flow.
const send = (event, props) => capture(event, props);

export const trackStartViewed = () => send("free_start_viewed");
export const trackStepCompleted = (step) => send("free_start_step_completed", { step });
export const trackStartError = (step, code) => send("free_start_error", { step, code: String(code) });
export const trackPhoneWaitShown = () => send("free_start_phone_wait_shown");
export const trackBannerViewed = (state) => send("free_event_banner_viewed", { state });
export const trackBannerAction = (state, action) => send("free_event_banner_action", { state, action });
export const trackCheckoutSheetOpened = () => send("checkout_sheet_opened");
export const trackCheckoutStarted = (plan, interval) => send("checkout_started", { plan, interval });
export const trackLimitedDashboardViewed = () => send("limited_dashboard_viewed");
export const trackLeadsCsvDownloaded = () => send("leads_csv_downloaded");
